export const GET_HOUSE_ENTRY_ACCESS_LIST = 'house/:houseId/entry-access/list';
export const UPDATE_HOUSE_ENTRY_ACCESS = 'house/:houseId/entry-access';
export const GET_HOUSE_AGENT_ENTRY_ACCESS = 'house/:houseId/entry-access';
export const ENTRY_ACCESS_AGENT_KEY_STATUS =
  'entry-access/management/keys-with-agent/agent/key/status';
export const ENTRY_ACCESS_AGENT_KEY_CONFIRM =
  'entry-access/management/keys-with-agent/agent/key/confirm';
export const ENTRY_ACCESS_AGENT_KEYS_WITH_AGENT =
  'entry-access/management/agent/keys-with-agent';
